import React from 'react';
import { Handle, Position, NodeResizer } from 'reactflow';

const InitialNode = ({ data, selected }) => {
    return (
        <div className="initial-node" style={{ position: 'relative', padding: '0px' }}>
            <NodeResizer isVisible={selected} /> {/* Enable resizing */}
            <div className="resizable-initialnode">
                {data.label}
            </div>
            <Handle type="source" position={Position.Right} id="right" />
            <Handle type="source" position={Position.Left} id="left" />
            <Handle type="source" position={Position.Top} id="top" />
            <Handle type="source" position={Position.Bottom} id="bottom" />

        </div>
    );
};

export default InitialNode;